module.exports = __webpack_public_path__ + "static/img/09044C_1_2_C_20210307_fit.0e0520f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09044C_1_2_C_20210307_fit.png
// module id = e9nP
// module chunks = 0